import api from 'api'
import { Button, Icon, Tooltip } from 'bold-ui'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import React from 'react'

import { ImpressaoAcompanhamentoPreNatalInput } from '../impressao/ImpressaoAcompanhamentoPreNatalInput'

interface ImprimirPreNatalButtonProps {
  disabled?: boolean
  tooltipMessage?: string
  atendimentoId: ID
  prontuarioId: ID
  dataAtendimento: Instant
}

export function ImprimirPreNatalButton(props: Readonly<ImprimirPreNatalButtonProps>) {
  const { disabled, tooltipMessage, atendimentoId, prontuarioId, dataAtendimento } = props
  const { handleImpressaoPath, handleImpressaoError } = useHandleImpressao()

  const handlePrint = () => {
    const input: ImpressaoAcompanhamentoPreNatalInput = {
      atendimentoId,
      prontuarioId,
      dataAtendimento,
    }

    handleImpressaoPath({
      apiPath: api.acompanhamentoPreNatal.imprimirAcompanhamentoPreNatal,
      values: input,
      file: 'Imprimir acompanhamento de pré-natal',
    }).catch(handleImpressaoError)
  }

  return (
    <Tooltip text={tooltipMessage ?? 'Imprimir'}>
      <Button onClick={handlePrint} type='button' size='small' skin='ghost' disabled={disabled}>
        <Icon icon='printerOutline' />
      </Button>
    </Tooltip>
  )
}
